
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitopuneinovacrystacab() {



    const cardData =
    {
        keyword: ' Mumbai to Pune Innova Crysta Cab',
        heading: 'Skyline Cabs: Mumbai to Pune Innova Crysta Cab',
        headingDescription: 'Skyline Cabs offers premium Mumbai to Pune Innova Crysta Cab service for a luxurious and comfortable intercity travel experience. Ideal for families, groups, or business travelers, our spacious and well-maintained Innova Crysta ensures a smooth and safe journey. With professional drivers, on-time pickups from anywhere in Mumbai, transparent pricing, and 24/7 support, Skyline Cabs is your trusted partner for reliable travel. Book your Mumbai to Pune Innova Crysta cab today and enjoy a first-class ride with complete peace of mind.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Mumbai to Pune Innova Crysta Cab Booking",
    "description": "Book an Innova Crysta for your journey from Mumbai to Pune with Skyline Cabs. Enjoy a luxurious and comfortable ride with ample space, perfect for families or groups. Our professional drivers ensure a smooth and hassle-free journey with competitive rates."
  },
  {
    "name": "Mumbai Airport to Pune Innova",
    "description": "Skyline Cabs offers premium Innova Crysta cabs for airport transfers from Mumbai to Pune. Experience comfort, reliability, and professional service, with the convenience of direct transfers to your desired destination."
  },
  {
    "name": "Pune to Mumbai Airport One Way Innova Cab",
    "description": "For your one-way journey from Pune to Mumbai Airport, choose our Innova Crysta cabs for a comfortable and reliable transfer. Our pricing is transparent, and our professional drivers ensure you reach the airport safely and on time."
  },
  {
    "name": "Mumbai Airport to Koregaon Innova Cab",
    "description": "Skyline Cabs provides Innova Crysta cabs for a comfortable ride from Mumbai Airport to Koregaon. Our cabs are spacious, clean, and well-maintained to ensure a pleasant journey. Book now for a stress-free transfer."
  },
  {
    "name": "Mumbai Airport to Viman Nagar Innova Cab",
    "description": "Travel from Mumbai Airport to Viman Nagar in style and comfort with our Innova Crysta cabs. Whether you’re traveling for business or leisure, our reliable service ensures a smooth and hassle-free ride."
  },
  {
    "name": "Mumbai Airport to Kothrud Innova Car Fare",
    "description": "Skyline Cabs offers competitive pricing for Innova Crysta cabs from Mumbai Airport to Kothrud. Enjoy a comfortable ride with no hidden charges, and travel in style and luxury with our well-maintained vehicles."
  },
  {
    "name": "Mumbai Airport to Pune Station Innova Cab",
    "description": "For a smooth and comfortable ride from Mumbai Airport to Pune Station, choose our Innova Crysta cabs. Our services are punctual and reliable, ensuring you arrive at your destination in comfort and on time."
  },
  {
    "name": "Innova Crysta on Rent Mumbai Airport",
    "description": "Rent an Innova Crysta directly from Mumbai Airport with Skyline Cabs. Ideal for long-distance travel, business trips, or family outings, our rental service offers competitive rates and the convenience of booking on the spot."
  },
  {
    "name": "Innova Hire in Mumbai",
    "description": "Skyline Cabs provides Innova Crysta hire services in Mumbai for various needs, including family trips, corporate travel, and long-distance journeys. Our vehicles are well-maintained, and our professional drivers ensure a safe and comfortable ride."
  },
  {
    "name": "Innova Per Km Rate in Mumbai",
    "description": "Our Innova Crysta per km rental rates in Mumbai are affordable and transparent. Whether you're planning a local or outstation trip, Skyline Cabs offers competitive pricing for the best service and comfort."
  },
  {
    "name": "Innova Crysta on Rent in Mumbai",
    "description": "Rent an Innova Crysta in Mumbai with Skyline Cabs for a luxury ride. Ideal for outstation travel, family vacations, and corporate trips, our vehicles are spacious and well-maintained, ensuring comfort and safety during your journey."
  },
  {
    "name": "Innova Car Rent Per Day in Mumbai",
    "description": "Skyline Cabs offers daily Innova Crysta car rentals in Mumbai. Whether you're planning a day trip, business travel, or family outing, our daily rental service ensures that you have a comfortable and stylish vehicle at your disposal."
  },
  {
    "name": "Innova Crysta on Rent in Mumbai",
    "description": "Skyline Cabs offers Innova Crysta rentals in Mumbai for various occasions. Rent a premium vehicle with a professional driver and experience a luxurious, comfortable ride, perfect for outstation trips or local sightseeing."
  },
  {
    "name": "Book Innova Crysta Cabs in Mumbai",
    "description": "Booking an Innova Crysta cab in Mumbai is easy with Skyline Cabs. Whether you need an airport transfer, outstation ride, or a local journey, our well-maintained Innova Crysta vehicles provide comfort, luxury, and affordability."
  },
  {
    "name": "Innova Crysta Car Hire Mumbai",
    "description": "Skyline Cabs provides Innova Crysta car hire services in Mumbai for all your travel needs. Whether it's a business trip, family outing, or a long-distance journey, our rental service offers flexible options and competitive pricing."
  }
],
"tableData": [
  ["Mumbai to Pune Innova Crysta Cab Booking", "Mumbai Airport to Pune Innova"],
  ["Pune to Mumbai Airport One Way Innova Cab", "Mumbai Airport to Koregaon Innova Cab"],
  ["Mumbai Airport to Viman Nagar Innova Cab", "Mumbai Airport to Kothrud Innova Car Fare"],
  ["Mumbai Airport to Pune Station Innova Cab", "Innova Crysta on Rent Mumbai Airport"],
  ["Innova Hire in Mumbai", "Innova Per Km Rate in Mumbai"],
  ["Innova Crysta on Rent in Mumbai", "Innova Car Rent Per Day in Mumbai"],
  ["Innova Crysta on Rent in Mumbai", "Book Innova Crysta Cabs in Mumbai"],
  ["Innova Crysta Car Hire Mumbai", ""]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai to Pune Innova Crysta Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and punctual Innova Crysta cab services from Mumbai to Pune. Whether you're traveling for business, leisure, or family, we ensure a smooth and comfortable journey every time."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Innova Crysta",
        "WhyChoosedescription": "Our fleet includes the premium Innova Crysta, a spacious and comfortable vehicle perfect for long-distance travel. Equipped with air-conditioning, ample legroom, and luxurious interiors, your ride from Mumbai to Pune will be relaxing and enjoyable."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced and well-trained, ensuring safe, smooth, and timely travel from Mumbai to Pune. They are familiar with the best routes and always prioritize your comfort and safety."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer competitive, upfront pricing for our Mumbai to Pune Innova Crysta cab services. There are no hidden charges, and you will always know the cost in advance, ensuring great value for your money."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Skyline Cabs operates 24/7, meaning you can book your Innova Crysta cab from Mumbai to Pune at any time of day or night. Whether it’s a last-minute trip or a planned journey, we are ready to serve you."
    },
    {
        "WhyChooseheading": "Easy and Quick Online Booking",
        "WhyChoosedescription": "Booking your Innova Crysta cab is easy with Skyline Cabs. Use our website or mobile app to book a ride in minutes, with instant confirmation and the ability to track your ride in real-time."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "Your health and safety are our top priority. All our Innova Crysta vehicles are thoroughly sanitized before each ride, and our drivers follow strict hygiene protocols to ensure a clean, safe, and hygienic environment."
    },
    {
        "WhyChooseheading": "Comfortable and Reliable Travel Experience",
        "WhyChoosedescription": "With Skyline Cabs, you’ll enjoy a reliable and comfortable travel experience from Mumbai to Pune in the Innova Crysta. The spacious interiors and smooth ride will make your journey a pleasant one."
    }
]























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book an Innova Crysta cab from Mumbai to Pune with Skyline Cabs?',
            answer:
                'Booking an Innova Crysta from Mumbai to Pune is quick and simple. Visit our website, use our mobile app, or call our customer support team. Just enter your travel details, select Innova Crysta as your preferred vehicle, and confirm the booking.',
        },
        {
            id: 2,
            question: 'Why choose an Innova Crysta for the Mumbai to Pune journey?',
            answer:
                'Innova Crysta is perfect for long-distance travel. It offers spacious seating, excellent comfort, and advanced safety features—ideal for families, small groups, or business travelers.',
        },
        {
            id: 3,
            question: 'How long does it take to travel from Mumbai to Pune in an Innova Crysta?',
            answer:
                'The travel time from Mumbai to Pune usually ranges between 3.5 to 5 hours, depending on traffic. Our experienced drivers take the best routes for a smooth and timely journey.',
        },
        {
            id: 4,
            question: 'Is the fare for an Innova Crysta from Mumbai to Pune fixed?',
            answer:
                'Yes, Skyline Cabs offers fixed pricing for Innova Crysta rides from Mumbai to Pune. The fare includes tolls, taxes, and driver charges—no hidden fees.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip Innova Crysta cab from Mumbai to Pune?',
            answer:
                'Absolutely. Just provide your return trip details while booking, and we’ll arrange a comfortable round-trip in an Innova Crysta for you.',
        },
        {
            id: 6,
            question: 'Can I make changes to my Mumbai to Pune Innova Crysta booking?',
            answer:
                'Yes, you can modify or cancel your booking anytime through our website, app, or customer service. We offer flexible options to suit your travel needs.',
        },
        {
            id: 7,
            question: 'Are the Innova Crysta vehicles well-maintained?',
            answer:
                'Yes, all our Innova Crysta cabs are regularly serviced and thoroughly cleaned. We ensure a safe, comfortable, and reliable journey every time.',
        },
        {
            id: 8,
            question: 'What are the payment options for my Innova Crysta ride?',
            answer:
                'You can pay online using credit/debit cards, UPI, and net banking. Cash payment at the end of the ride is also available.',
        },
        {
            id: 9,
            question: 'Is the Innova Crysta available for corporate travel from Mumbai to Pune?',
            answer:
                'Yes, the Innova Crysta is a preferred choice for corporate travel. We offer customized packages for business trips and professional requirements.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for an Innova Crysta from Mumbai to Pune?',
            answer:
                'Skyline Cabs offers top-notch vehicles, trained drivers, fixed pricing, and reliable service. Our Innova Crysta rides are perfect for a smooth, premium experience from Mumbai to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Booked an Innova Crysta from Mumbai to Pune for a family trip. Super spacious, clean, and very comfortable. Skyline Cabs delivered exactly what they promised!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Used Skyline’s Innova Crysta service for a business trip from Mumbai to Pune. Great ride and professional driver. Will use again!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Innova Crysta Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-pune-innova-crysta-cab.jpg",
  "description": "Book a premium Mumbai to Pune Innova Crysta cab with Skyline Cabs. Enjoy spacious, air-conditioned, and comfortable travel with experienced drivers—ideal for families, groups, or corporate travel, available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7931"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-pune-innova-crysta-cab"
  }
};


      
     
      



    return (
        <div>
<Helmet>
  <title>Mumbai to Pune Innova Crysta Cab | Spacious AC SUV | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book a premium Mumbai to Pune Innova Crysta cab with Skyline Cabs. Enjoy spacious, air-conditioned, and comfortable travel with experienced drivers—ideal for families, groups, or corporate travel, available 24/7." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pune Innova Crysta Cab, Innova Crysta SUV Mumbai Pune, Premium SUV Cab Mumbai to Pune, 6 Seater Cab Mumbai Pune, Family Cab Mumbai to Pune, AC SUV Mumbai Pune, Online Innova Cab Booking, 24/7 Innova Taxi Mumbai to Pune, Skyline Cabs Mumbai Pune Innova, SUV Rental Mumbai Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/54.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopuneinovacrystacab;